import React, { useState } from 'react';

const HomepageBanner = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    printerModel: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    type: '',
    text: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', text: '' });

    try {
      const response = await fetch('/contact-form.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Unable to submit your request.');
      }

      setSubmitStatus({
        type: 'success',
        text: 'Thank you! We will contact you soon.',
      });
      setFormData({ name: '', phone: '', email: '', printerModel: '' });
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        text: error.message || 'Something went wrong. Please try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className='hero-banner'>
      <div className='hero-banner__inner'>
        <div className='hero-banner__content'>
          <div
            className='hero-banner__image'
            style={{ marginBottom: '24px', maxWidth: '100%' }}
          >
            <img
              src='/images/404dn.jpeg'
              alt='Printer'
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <p className='hero-banner__subtitle'>
            INKJET &bull; LASER &bull; ALL-IN-ONE PRINTERS
          </p>
          <h1 className='hero-banner__title'>
            Find the Perfect Printer for Every Need
          </h1>
          <p className='hero-banner__desc'>
            Browse top-rated printers from trusted brands — whether it's for
            home, office, or high-volume work, we've got you covered with
            genuine products and hassle-free checkout.
          </p>
          <div className='hero-banner__badges'>
            <a
              href='https://locator.hp.com/us/en/?ml___task=search_zip&ml___id=570276&ml___ml_skip_interstitial=1&ml___url_share_action=1&ml___lang=en-US%20(1)&ml___redirect_commercial_destination_Itemid=1'
              target='_blank'
            >
              <img
                src='/images/hp-partner.png'
                alt='HP'
                style={{ height: 80 }}
              />
            </a>
            <div
              style={{
                background: '#fff',
                padding: '10px 20px',
                borderRadius: '8px',
              }}
            >
              <a
                href='https://www.trustpilot.com/review/itfixed247.com'
                target='_blank'
              >
                <img
                  src='/images/trustpilot.png'
                  alt='Trustpilot'
                  style={{ height: 45 }}
                />
              </a>
            </div>
          </div>
        </div>

        {/* Inline contact form on the right */}
        <div className='hero-banner__form'>
          <div
            style={{
              background: '#ffffff',
              borderRadius: '12px',
              padding: '28px 24px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
            }}
          >
            <h2 style={{ margin: '0 0 4px', fontSize: '1.3rem' }}>
              Contact Us
            </h2>
            <p
              style={{
                margin: '0 0 16px',
                color: '#6b7280',
                fontSize: '0.9rem',
              }}
            >
              We'll get back to you as soon as possible.
            </p>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='name'
                  style={{
                    display: 'block',
                    marginBottom: '6px',
                    fontWeight: 500,
                    fontSize: '0.9rem',
                  }}
                >
                  Name
                </label>
                <input
                  id='name'
                  name='name'
                  type='text'
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='phone'
                  style={{
                    display: 'block',
                    marginBottom: '6px',
                    fontWeight: 500,
                    fontSize: '0.9rem',
                  }}
                >
                  Phone
                </label>
                <input
                  id='phone'
                  name='phone'
                  type='tel'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='email'
                  style={{
                    display: 'block',
                    marginBottom: '6px',
                    fontWeight: 500,
                    fontSize: '0.9rem',
                  }}
                >
                  Email
                </label>
                <input
                  id='email'
                  name='email'
                  type='email'
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='printerModel'
                  style={{
                    display: 'block',
                    marginBottom: '6px',
                    fontWeight: 500,
                    fontSize: '0.9rem',
                  }}
                >
                  Printer Model
                </label>
                <input
                  id='printerModel'
                  name='printerModel'
                  type='text'
                  value={formData.printerModel}
                  onChange={handleInputChange}
                  required
                  placeholder='e.g. HP LaserJet Pro M404n'
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              {submitStatus.text && (
                <p
                  style={{
                    color:
                      submitStatus.type === 'error' ? '#b91c1c' : '#166534',
                    margin: '0 0 12px',
                    fontSize: '0.9rem',
                  }}
                >
                  {submitStatus.text}
                </p>
              )}

              <button
                type='submit'
                disabled={isSubmitting}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '6px',
                  border: 'none',
                  background: '#111827',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '1rem',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  opacity: isSubmitting ? 0.7 : 1,
                }}
              >
                {isSubmitting ? 'Sending...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomepageBanner;
